import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from './../../../utils/url';
import axios from './../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapPerformance from './../../../components/OrganizationSetup/MapPerformance/MapPerformance';
import EnterpriseBreadcrumb from './../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapPerformanceManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      const {performance} = payload.mapping;
      if(performance.columnName) {
        this.props.onMatchColumn(performance.columnName);
      }
      const performanceData = performance.data;
      let allMapping = []
      performanceData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllPerformanceMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapPerformanceStep();
  }

  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    return (
      <div className="mt60 enterprise-map-page">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Performance"
        {...this.props}
        />
      <MapPerformance 
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipPerformanceMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapPerformance : state.mapping.performance
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapPerformanceStep: () => dispatch(actionCreators.resetMapPerformanceStep()),
    nextStep: () => dispatch(actionCreators.mapPerformanceNextStep()),
    goBack : () => dispatch(actionCreators.mapPerformanceGoBack()),
    reset : () => dispatch(actionCreators.resetPerformance()),
    saveAllPerformanceMapping : (o,s) => dispatch(actionCreators.saveAllPerformanceMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapPerformanceUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapPerformanceMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapPerformanceManagement);